export default __webpack_public_path__ + "assets/images/vector.df7ab0.avif";